import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@hs/ui-core-inputs';

import { DashboardWithoutWidgets } from '../../../models/dashboard-without-widgets';
import { ViewTile } from '../../../models/view-tile';
import { PeerCarouselComponent } from '../peer-carousel/peer-carousel.component';

export type EditAction = 'save' | 'cancel' | 'revert';

@Component({
    selector: 'ddv-dashboard-name-edit',
    templateUrl: './header-name-edit.component.html',
    styleUrls: ['./header-name-edit.component.scss'],
    imports: [
        ButtonComponent,
        PeerCarouselComponent,
    ],
})
export class HeaderNameEditComponent {
    @Input() dashboard: DashboardWithoutWidgets | undefined;
    @Input() group: ViewTile | undefined;
    @Input() isDirty = false;

    @Output() dashboardSwitch = new EventEmitter<string>();
    @Output() editAction = new EventEmitter<EditAction>();
}
